import { API_URL } from '../../../../utils/config';

export const GET_DEDICATED_INVOICE_URL = `${API_URL}/dedicated/dedicated_expiration`;
export const UPDATE_DEDICATED_INVOICE_URL = `${API_URL}/dedicated/update_dedicated_expiration`;
